export const APKUrl =
  "https://play.google.com/store/apps/details?id=com.corplandtechnologies.corpland&pcampaignid=web_share";

  export const appleAppURL = "https://apps.apple.com/gh/app/corpland/id6670435009"